const SearchPageControl = (props) => {
    const handleNavigationClick = (event) => {
        let target = event.target
        props.pageNavigationFunction(+target.innerHTML)
    }

    const handleFirstPageNavigationClick = () => {
        props.pageNavigationFunction(1)
    }

    const handleLastPageNavigationClick = () => {
        props.pageNavigationFunction(props.numberOfPages)
    }

    const getPageNumbers = () => {
        const numberList = []
        if (!props.numberOfPages) {
            return numberList;
        }

        for (let i = props.currentPage - 4; i <= props.currentPage + 4; i++) {
            if (i > 0 && i <= props.numberOfPages) {
                numberList.push(i)
            }
        }
        numberList[0] !== 1 ? numberList.unshift(1) : null;
        numberList[numberList.length - 1] !== props.numberOfPages ? numberList.push(props.numberOfPages) : null;
        return numberList;
    }

    const getNumberElements = () => {
        const pageNumbers = getPageNumbers();
        const elements = [];
        if (!pageNumbers.length) {
            return elements;
        }

        elements.push(<li className="paginate__control paginate__control--next paginate-left paginate__item" onClick={handleFirstPageNavigationClick} dangerouslySetInnerHTML={{ __html: getLeftRightIcon('left') }} />);

        let previousNumber = 0;
        for (let pageNumber of pageNumbers) {
            if (+pageNumber - previousNumber > 1) {
                elements.push(<li className="paginate__item">...</li>)
            }
            elements.push(listElement(+pageNumber));
            previousNumber = +pageNumber;
        }

        elements.push(<li className="paginate__control paginate__control--next paginate-right paginate__item" onClick={handleLastPageNavigationClick} dangerouslySetInnerHTML={{ __html: getLeftRightIcon('right') }} />);
        return elements;
    }

    const getLeftRightIcon = (direction) => {
        return '<span class="icon-wrap"><svg aria-hidden="true" class="icon icon--angle-' + direction + '-bold icon--red"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-angle-' + direction + '-bold"></use></svg></span>';
    }

    const listElement = (pageNumber) => {
        var cls = (pageNumber === props.currentPage ? "active " : "") + "paginate__item";
        return <li className={cls} onClick={handleNavigationClick}><a>{pageNumber}</a></li>
    }

    return (
        <nav className="paginate" aria-label="Page navigation">
            <ul className="paginate__list">{getNumberElements()}</ul>
        </nav>
    )
}

export default SearchPageControl